<template>
    <div class="l-team-stats">
        <div class="l-team-stats__head">
            <span class="l-team-stats__dot" :style="{ backgroundColor: color1 }" />
            <span class="l-team-stats__title">Team stats</span>
            <span class="l-team-stats__dot" :style="{ backgroundColor: color2 }" />
        </div>
        <div v-for="row in rows" :key="row.label" class="l-team-stats__row">
            <span class="l-team-stats__value" :class="{ 'l-team-stats__value--lead': row.team1 > row.team2 }">{{ row.team1 }}</span>
            <span class="l-team-stats__bar">
                <span class="l-team-stats__bar-1" :style="{ width: share(row, 1) + '%', backgroundColor: color1 }" />
                <span class="l-team-stats__bar-2" :style="{ width: share(row, 2) + '%', backgroundColor: color2 }" />
                <span class="l-team-stats__label">{{ row.label }}</span>
            </span>
            <span class="l-team-stats__value" :class="{ 'l-team-stats__value--lead': row.team2 > row.team1 }">{{ row.team2 }}</span>
        </div>
    </div>
</template>

<script>
    // Team totals side by side, each row a bar split in the two team colours. rows: [{ label, team1, team2 }]
    export default {
        name: 'StatsTeamStats',
        props: {
            rows: {
                type: Array,
                default: () => []
            },
            color1: {
                type: String,
                default: '#000000'
            },
            color2: {
                type: String,
                default: '#000000'
            }
        },
        methods: {
            // share of the bar for one team (50/50 when both are 0)
            share(row, side) {
                const total = row.team1 + row.team2
                if (!total) return 50
                return Math.round(((side === 1 ? row.team1 : row.team2) / total) * 100)
            }
        }
    }
</script>
